import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../common/services/common.service';
import { DataService } from '../../../core/data/data-service';
import { PriceContentService } from '../../../core/routing/services/asset-library/price-content.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { RouterConstants } from './../../../core/routing/constants/app-paths.constant';
import { PriceContent, PriceContentConfiguration, PriceContentGroupPage, CreatePriceContentResponse, PriceContentViewModel } from './interfaces/price-content.i';
import { Utils } from '../../../common/utils/utils';
import { ProfileRequest, ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { SendToStoreService } from '../../../core/routing/services/asset-library/send-to-store.service';
import { LanguageConstants } from '../../header/constants/lang.consts';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageComponent } from '../page/page.component';


@Component({
  selector: 'iposcen-price-content',
  templateUrl: './price-content.component.html',
  styleUrls: ['./price-content.component.scss']
})

export class PriceContentComponent implements OnInit, OnDestroy {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('sendToAccountModal') sendToAccountModal: ElementRef;
  @ViewChild('page1') page1: PageComponent;
  @ViewChild('page2') page2: PageComponent;
  @ViewChild('page3') page3: PageComponent;
  @Input() isdevicePrice = true;
  @Output() readonly sendPriceContentData = new EventEmitter();
  @Output() readonly sendLengthPriceContent = new EventEmitter();
  @Input() idFromPriceContent;

  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  lockContentText = GlobalConstants.CONTENT_LOCKED;
  isStoreUser: boolean;
  configurations: PriceContentConfiguration[];
  tabIndex = 0;
  allPriceContentGroups: PriceContent[];
  displayPriceContentGroups = [];
  selectedFiles: FileList;
  sideNav = 'price';
  sortValue = GlobalConstants.CREATED_DATE;
  page = 1;
  pageSize = 5;
  maxSize = 5;
  contentGrpData: any;
  pageType = GlobalConstants.PRICE_CONTENT_GROUP;
  priceCGToDelete: string;
  priceCGToDeleteName: string;
  LCGlayout = 1;
  pages: any; // update the no of pages for edit.
  mediaObjects: any[] = [];
  editCheck: boolean;
  currentdetailPage: string;
  checkIndex = 0;
  checkInd: number;
  checkInd2: number;
  presentPage: string;
  sendButtonText: string;
  isSendToStore = false;
  priceContentIdInfo: string;
  sendNameToStore: string;
  retailHQUser: string;
  isRetailerUser: boolean;
  details: string = ' Details';
  profile_page: string = GlobalConstants.PROFILE;
  isDisabled: boolean;
  clickable = false; // This is to enable tabs click only after clicking on Save & Proceed.TODO: will remove this later.
  showPriceContentName: string;
  createdDateLabel: string;
  groupNameLabel: string;
  pageGrpForm: any;
  showDevice = false;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  assets_page: string = GlobalConstants.ASSET_LIBRARY
  deviceDashboardPage: string = GlobalConstants.DEVICES;
  selctedContGrpsForProfile: any = {
    contentGrps: []
  };
  buttonName: string;
  isNavigated: boolean = false;
  newPriceContentTitle: string = $localize`:@@price-content.tab-pane.new-price-content-group:NEW PRICE CONTENT GROUP`;
  YES: string = GlobalConstants.YES;
  NO: string = GlobalConstants.NO;
  profileDataSet: ProfileRequest;
  profileLogoContentData: any = [];
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  addToPackageDisabled = GlobalConstants.ADD_TO_PACKAGE_DISABLED;
  tooltipEdit: string = GlobalConstants.EDIT;
  tooltipDelete: string = GlobalConstants.DELETE;
  tooltipContentGroup: string = GlobalConstants.CONTENT_GROUP;
  tooltipSendToStore = GlobalConstants.OPTIONAL_TOOLTIP;
  isPage3Created: boolean;
  priceContentGroupLabel = GlobalConstants.PRICE_CONTENT_GROUP_TEXT;
  changePlacement: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  pageError = new Map([[1, false], [2, false], [3, false]]);
  buttonLable = GlobalConstants.OK_BUTTON;
  errorMessageText = GlobalConstants.PAGE_ERROR_MESSAGE;
  errorMessageText1 = GlobalConstants.PAGE_ERROR_MESSAGE1;
  errorMessageText2 = GlobalConstants.PAGE_ERROR_MESSAGE2;
  errorMessageText3 = GlobalConstants.PAGE_ERROR_MESSAGE3;
  errorMessageText4 = GlobalConstants.PAGE_ERROR_MESSAGE4;
  errorMessageText5 = GlobalConstants.PAGE_ERROR_MESSAGE5;
  errorMessageText6 = GlobalConstants.PAGE_ERROR_MESSAGE6;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  internalName = GlobalConstants.INTERNAL_NAME;
  isRegionalHQ: boolean;
  globalconst = GlobalConstants;
  isPriceContentNone: boolean;
  deviceExists: boolean;
  whichPageDelete: any;
  pagelen: number;
  showPreviewLayout: boolean;

  constructor(
    private router: Router,
    private cmnService: CommonService,
    private priceContentService: PriceContentService,
    private dataService: DataService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private sendToStoreService: SendToStoreService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.priceContentIdInfo = '';
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    if (this.profileStoreService?.currentWorkingProfile) {
      this.profileDataSet = JSON.parse(JSON.stringify(this.profileStoreService?.currentWorkingProfile));
    }
    this.retailHQUser = sessionStorage.getItem('userRole');
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser') || false;
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ') || false;
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER) || false;
    this.createdDateLabel = GlobalConstants.CREATED_DATE;
    this.groupNameLabel = GlobalConstants.GROUP_NAME;
    this.cmnService.pageObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      if(data.media.format === 'video/mp4' && ((data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS && data.fullScreenCheckbox) || (data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE && data.idleExpFullscreenEnabled))) {
        this.showPreviewLayout = false;
      } else {
        this.showPreviewLayout = true;
      }
    });      
    this.getAllPriceContentsByUser();
    this.pages = {};
    this.editCheck = false;
    this.currentdetailPage = this.router.url;
    // set presentpage
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.DEVICE_DASHBOARD) {
      this.presentPage = GlobalConstants.DEVICES;
    }
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        // pages data. To-Do: update to common object ;
        // const updatePromoContent: CreatePromoContentResponse = this.contentGrpData as CreatePromoContentResponse;
        // Once page is updated.
        const priceContent = this.contentGrpData.priceContent;
        // console.log(logoContent.configurations,"...ss")
        const configurations = priceContent.configurations;
        if (res.data.media.url !== '') {
          this.prepareMediaSet(res, priceContent.id);
        }
        const checkJson = this.checkExistance(configurations.contentGroupPages, 'pageNum', res.number);
        if (checkJson.hasMatch) {// If there is configuration object already for the page number
          // Update the pages
          configurations.contentGroupPages[checkJson.matchedIndex] = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '',
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
        } else {
          const promoContentGroupPage: PriceContentGroupPage = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '',
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
          configurations.contentGroupPages.push(promoContentGroupPage);
        }
      });
    if (this.idFromPriceContent) {
      this.sendPriceData({ id: this.idFromPriceContent });
    }
  }
  openPopup(modal) {
    this.modalService.open(modal);
  }
  getPageError(data) {
    this.pageError.set(data[1], data[0])
  }
  resetPage() {
    this.pageError = new Map([[1, false], [2, false], [3, false]]);
  }
  goToErrorPage() {
    if (this.pageError.get(1) === true) {
      this.tabIndex = 2
    } else if (this.pageError.get(2) === true) {
      this.tabIndex = 3
    } else {
      this.tabIndex = 4
    }
  }
  sendPriceData(data) {
    this.sendPriceContentData.emit(data);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  openPopupPrice(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }

  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.updated(undefined,undefined,'',1);
    }
    let configurations;
    let updatedPages = [];
    
    if (typeof this.contentGrpData.priceContent.configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData.priceContent.configurations) as PriceContentConfiguration;
    } else {
      configurations = this.contentGrpData.priceContent.configurations as PriceContentConfiguration;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    if (this.page1) {
      this.page1.updated(configurations,AssetLibraryConstants.PRICE_CONTENTS,'price');
    } else if (this.page2) {
      this.page2.updated(configurations,AssetLibraryConstants.PRICE_CONTENTS,'price');
    } else {
      this.page3.updated(configurations,AssetLibraryConstants.PRICE_CONTENTS,'price');
    }
  }

  setCreatedGrpID(data) {
    this.buttonName = this.priceContentService.buttonName;
    if (typeof data === 'object' && data.cancel) {
      this.pages = {};
      this.editCheck = false;
      this.setIndex(0);
    } else {
      this.contentGrpData = data;
      if (typeof this.contentGrpData.priceContent.configurations === 'string') {
        this.contentGrpData.priceContent.configurations =
          JSON.parse(this.contentGrpData.priceContent.configurations) as PriceContentConfiguration;
      }
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.showPriceContentName = this.contentGrpData.priceContent.configurations.publishedName;
      this.clickable = true;
      this.setIndex(2);
    }
    // this.mediaObjects = [];
  }
  fontSizeNumber(size) {
    if (size === GlobalConstants.SMALL) {
      return GlobalConstants.NUMBER_12;
    }
    if (size === GlobalConstants.MEDIUM) {
      return GlobalConstants.NUMBER_14;
    }
    if (size === GlobalConstants.LARGE) {
      return GlobalConstants.NUMBER_16;
    }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return GlobalConstants.TWO_COL_RIGHT_ASSET;
    } else if (id === 2) {
      return GlobalConstants.TWO_COL_LEFT_ASSET;
    } else if (id === 3) {
      return GlobalConstants.ONE_COL_MID_ASSET;
    }
  }
  refreshPriceContentdata() {
    this.getAllPriceContentsByUser();
    this.setIndex(0);
  }

  setPreviewLayout(data) {
    this.LCGlayout = data;
  }

  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.fontSizeNumber(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.PRICE_CONTENTS + AssetLibraryConstants.SLASH +
          gId + AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 3,
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true
    };

    return this.pageGrpForm;
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }
  checkExistance(data, key, compValue) {
    const checkJSON = { hasMatch: false, matchedIndex: -1 };
    for (let index = 0; index < data.length; index += 1) {
      if (data[index][key] === compValue) {
        checkJSON.hasMatch = true;
        checkJSON.matchedIndex = index;
        break;
      }
    }

    return checkJSON;
  }

  // To hold all pages media objects and its metada.
  prepareMediaSet(res: any, promoContentId: string) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = {
        id: promoContentId,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj: any = {
        id: promoContentId,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }
  }

  setSideNav(value: string) {
    this.sideNav = value;
  }

  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(2);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(3);
    } else {
      this.pages.page3 = true;
      this.setIndex(4);
    }
    this.isPage3Created = this.checkPages();
    this.pagelen = Object.entries(this.pages).length;
  }

  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }

    return false;
  }

  getAllPriceContentsByUser() {
    this.editCheck = false;
    this.priceContentService.getAllPriceContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllPriceContentResponse => {
        this.allPriceContentGroups = (getAllPriceContentResponse.priceContent as PriceContent[]);
        this.configurations = [];
        this.isPriceContentNone = true;
        this.sendLengthPriceContent.emit(this.allPriceContentGroups.length);
        this.allPriceContentGroups.forEach(priceContentGroup => {
          try {
            this.configurations.push(JSON.parse(priceContentGroup.configurations) as PriceContentConfiguration);
          }
          catch (err) {

          }
        });
        // display Price content groups using displayPricecontentgroups var as configurations is coming as string
        this.displayPriceContentGroups = [];

        this.allPriceContentGroups.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayPriceContentGroups.push(ele);
        });

        this.displayPriceContentGroups.forEach(element => {
          // adding this custom property to know which Price content is expanded
          element.isExpanded = false;
          element.previewTabIndex = 0; // For new implementation of preview IIT2_4655
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          // if deleting make it true
          element.isDeleted = false;

          // TODO: Is the below commented code block needed?
          // fetch images from s3
          // this.fetchImagesForLogoCGPages(element.id);

          // converting date for display purpose:
          if (element && element.configurations) {
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
              //changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
              // element.configurations.publishTime = new Date(element.configurations.publishTime).toLocaleString()
              //   .replace(',', '');
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              //changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
              // element.configurations.expireTime = new Date(element.configurations.expireTime).toLocaleString()
              //   .replace(',', '');
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
            if (element.configurations?.formFactor) {
              element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
            }
          }
          if ((this.presentPage === GlobalConstants.PROFILE)) {
            element.showOnDevice = false;
            element.addToPackage = false;
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredContentdata(element);
        });

        this.sortByDate();
        if (this.presentPage === this.profile_page) {
          this.displayPriceContentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
          this.selctedContGrpsForProfile = {
            contentGrps: []
          };
          this.prefillProfileData();
          this.displayPriceContentGroups.forEach((element, index) => {
            element.index = index;
            if (this.isPriceContentNone) {
              this.isPriceContentNone = !element.showOnDevice;
            }
          });
          //TODO MULTIPLE CONDITIONS
          if (this.showDevice) {
            let logCont = this.displayPriceContentGroups
              .filter(a => a.addToPackage === true)
              .sort((a, b) => new Date(a.updateTime).getTime() - new Date(b.updateTime).getTime());
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.PRICE_CONTENT_GRP_MAX_IN_PACKAGE) {
              this.setPackageNshowOnDeviceVal(logCont[0].index, false);//if limit reached. set values to false since we are de-selecting
            }
            if (this.selctedContGrpsForProfile.showOnDevice) {
              this.findIndexAndSetValue(GlobalConstants.DISPLAY_PRICE_CONTENT, GlobalConstants.ID, false);//de-select in display logo content
              this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.PRICE_CONTENT_ID, false);//de-select in selectedCntGrps
            }
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.PRICE_CONTENT_GRP_MAX_IN_PACKAGE) {
              //Since maximum limit reached remove the earliest created one
              this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
                .filter(a => a.priceContentId !== logCont[0].id);
            }
            this.displayPriceContentGroups[0].addToPackage = true;// add to package/showondevice since selected yes on pop-up
            this.displayPriceContentGroups[0].showOnDevice = true;
            this.pushToSelectedGrps(0);
            this.selctedContGrpsForProfile.showOnDevice = this.displayPriceContentGroups[0].id;
            //update back to profile/ and profile store
            this.createProfileService.updateProfile(
              this.profileDataSet?.profileId, { priceContents: this.selctedContGrpsForProfile.contentGrps }
            )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);

              });
          }
        }
      },
        error => {
          // do something
        });
  }

  changeLockContentStatus(id: string, eventObj: any, object: []) {
    const status = eventObj.target.checked ? GlobalConstants.LOCK_CONTENT_LOCK : GlobalConstants.LOCK_CONTENT_UNLOCK;
    this.cmnService.changeLockContentStatus(id, status, AssetLibraryConstants.PRICE_CONTENTS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
        this.displayPriceContentGroups[this.displayPriceContentGroups.indexOf(object)].islocked = eventObj.target.checked;
      });
  }

  prefillProfileData() {
    // for edit profile - logo content tab
    const existingProfileData = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    if (existingProfileData && existingProfileData?.profileId) {
      this.profileDataSet = existingProfileData as ProfileRequest;
      this.profileLogoContentData = this.profileDataSet.priceContents;
      if (this.profileLogoContentData?.length) {
        if (this.profileDataSet?.priceContents?.length === 1 && !this.profileDataSet?.priceContents[0].showOnDevice && this.profileDataSet?.priceContents[0].priceContentId === undefined) {
          this.selctedContGrpsForProfile.contentGrps = [];
        } else {
          this.selctedContGrpsForProfile.contentGrps = this.profileDataSet.priceContents;
        }
        this.selctedContGrpsForProfile.contentGrps.forEach((ele, ind) => {
          let contentIdInd = this.displayPriceContentGroups.findIndex(each => each.id === ele.priceContentId);
          if (contentIdInd != -1) {
            this.displayPriceContentGroups[contentIdInd].addToPackage = true;
            this.displayPriceContentGroups[contentIdInd].showOnDevice = ele.showOnDevice;
            if (ele.showOnDevice) {
              this.selctedContGrpsForProfile.showOnDevice = this.displayPriceContentGroups[contentIdInd].id;
            }
          }
        });
      }
    }
  }

  editPrice(priceCGID: string) {
    this.pages = {};
    this.mediaObjects = [];
    const priceCGToEdit = this.displayPriceContentGroups.find(ele => ele.id === priceCGID);
    this.dataService.setPriceContent(priceCGToEdit);
    this.editCheck = true;
    for (let each of priceCGToEdit.configurations.contentGroupPages) {
      if (each.pageNum === 1) {
        this.pages.page1 = true;
      }
      if (each.pageNum === 2) {
        this.pages.page2 = true;
      }
      if (each.pageNum === 3) {
        this.pages.page3 = true;
      }
    }
    const tempPromoCont = priceCGToEdit as PriceContent;
    this.pagelen = Object.entries(this.pages).length;
    this.contentGrpData = {
      priceContent: tempPromoCont,
      responseContext: {}
    }; // set data to cntGrpData to show in pages
    this.showPriceContentName = priceCGToEdit.configurations.publishedName;
    this.setIndex(1);
  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'createDate': {
        this.sortValue = GlobalConstants.CREATED_DATE;
        this.displayPriceContentGroups.sort((price1, price2) => price2.updateTime - price1.updateTime);
        break;
      }
      case 'groupName': {
        this.sortValue = GlobalConstants.GROUP_NAME;
        this.displayPriceContentGroups.sort((price1, price2) =>
          price1.configurations.publishedName.localeCompare(price2.configurations.publishedName));
        break;
      }
      default:
        break;
    }
  }

  duplicateAndEditPriceContent(priceContentId: string) {
    const priceContentToEdit = this.displayPriceContentGroups.find(ele => ele.id === priceContentId);
    const priceContentConfig = priceContentToEdit.configurations;
    if (priceContentConfig.contentGroupPages) {
      priceContentConfig.contentGroupPages.forEach(page => {
        page.image = undefined;
      });
    }
    if (priceContentConfig?.publishTime && !priceContentConfig?.isPublishDateNow) {
      //changing it to old format
      priceContentConfig.publishTime = Utils.changeSaveDateFormat(priceContentConfig?.publishTime);
    }
    if (priceContentConfig?.expireTime && priceContentConfig?.expireTime !== GlobalConstants.NEVER) {
      //changing it to old format
      priceContentConfig.expireTime = Utils.changeSaveDateFormat(priceContentConfig?.expireTime);
    }
    const priceContent: PriceContentConfiguration = {
      publishedName: `Copy of ${priceContentConfig.publishedName}`,
      internalName: priceContentConfig.internalName,
      publishTime: priceContentConfig.publishTime ? priceContentConfig.publishTime : new Date().toString(),
      expireTime: priceContentConfig.expireTime ? priceContentConfig.expireTime : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: priceContentConfig.contentScheduleTimezoneCode,
      type: GlobalConstants.PRICE_CONTENT_GROUP,
      contentGroupPages: priceContentConfig.contentGroupPages,
      formFactor: priceContentConfig.formFactor,
      isPublishDateNow: priceContentConfig.isPublishDateNow,
      isPublishExpiryNever: priceContentConfig.isPublishExpiryNever
    };
    this.priceContentService.createPriceContent(JSON.stringify(priceContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createPriceContentResponse => {
        this.getDetailsOfPriceCG(priceContentId);
        const createPriceContentResponseObj: CreatePriceContentResponse = createPriceContentResponse as CreatePriceContentResponse;
        const priceContentViewModel: PriceContentViewModel = createPriceContentResponseObj.priceContent as unknown as PriceContentViewModel;
        priceContentViewModel.configurations =
          JSON.parse(createPriceContentResponseObj.priceContent.configurations) as PriceContentConfiguration;
        if (priceContentToEdit?.configurations && priceContentToEdit.configurations.contentGroupPages?.length) {
          for (let page of priceContentToEdit.configurations.contentGroupPages) {
            // Loop and duplicate images
            await this.duplicatePriceContentImage(priceContentToEdit, priceContentViewModel, page);
          }
        }
        if (priceContentViewModel && priceContentViewModel.configurations) {
          if (priceContentViewModel.configurations?.publishTime &&
            !priceContentViewModel.configurations.isPublishDateNow) {
            //changing it to old format
            priceContentViewModel.configurations.publishTime =
              Utils.ChangetoOldFormat(priceContentViewModel.configurations.publishTime);
          }
          if (priceContentViewModel.configurations.expireTime &&
            priceContentViewModel.configurations.expireTime !== GlobalConstants.NEVER) {
            //changing it to old format
            priceContentViewModel.configurations.expireTime =
              Utils.ChangetoOldFormat(priceContentViewModel.configurations.expireTime);
          }
        }
        this.dataService.setPriceContent(priceContentViewModel);
        this.editCheck = true;
        for (let each of priceContentViewModel.configurations.contentGroupPages) {
          if (each.pageNum === 1) {
            this.pages.page1 = true;
          }
          if (each.pageNum === 2) {
            this.pages.page2 = true;
          }
          if (each.pageNum === 3) {
            this.pages.page3 = true;
          }
        }
        this.contentGrpData = {
          priceContent: priceContentViewModel,
          responseContext: {}
        }; // set data to cntGrpData to show in pages
        const tempViewModel: any = priceContentViewModel; // dummy instance to add all required  flags for expand,delete,sort by date&time format
        tempViewModel.isExpanded = false;
        tempViewModel.previewTabIndex = 0;// IIT2_4655
        tempViewModel.createdByUser = (tempViewModel.createdByUser === this.userId) ? GlobalConstants.ME : tempViewModel.createdByUser;
        if (tempViewModel.updateTime) {
          tempViewModel.updateTime = new Date(tempViewModel.updateTime);
          tempViewModel.updateTimeDisplay = new Date(tempViewModel.updateTime).toLocaleString()
            .replace(',', '');
        }
        tempViewModel.isDeleted = false;
        /*if (tempViewModel && tempViewModel.configurations) {
          if (tempViewModel.configurations.publishTime) {
            tempViewModel.configurations.publishTime = new Date(tempViewModel.configurations.publishTime).toLocaleString()
              .replace(',', '');
          }
          if (tempViewModel.configurations.expireTime && tempViewModel.configurations.expireTime !== GlobalConstants.NEVER) {
            tempViewModel.configurations.expireTime = new Date(tempViewModel.configurations.expireTime).toLocaleString()
              .replace(',', '');
          }
        }*/
        // this.displayPriceContentGroups.push(tempViewModel);
        //this.displayPriceContentGroups.push(priceContentViewModel);
        tempViewModel.addToPackage = tempViewModel.showOnDevice = false;
        this.displayPriceContentGroups.unshift(tempViewModel);
        if (this.presentPage === this.profile_page) {
          this.displayPriceContentGroups.forEach((element, index) => {
            element.index = index;
          });
        }
        if (this.sortValue === 'Created Date') {
          this.sortBy('createDate');
        } else {
          this.sortBy('groupName');
        }
        this.showPriceContentName = priceContent.publishedName;
        this.page = 1;
        this.setIndex(1);
      },
        error => {
        }
      );
  }

  duplicatePriceContentImage(priceContent: any, newPriceContent: any, page: any) {
    return new Promise((resolve, reject) => {
      if (page.linkedAsset) {
        this.priceContentService.getPriceContentByPageId(priceContent.id, page.pageNum)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            this.priceContentService.putS3PriceContentByPageId(imageData, 'png', newPriceContent.id, page.pageNum) // Check how to get image type
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                resolve(data);//ToDo: Need to add reject too.
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      } else {
        resolve({});//ToDo: just sending empty, to continue the flow;
      }
    });
  }

  setIndex(value: number) {
    this.tabIndex = value;
    // if user in profile and going to logo content group tab -> refresh this.selctedContGrpsForProfile
    if (this.presentPage === this.profile_page && this.tabIndex === 1) {
      this.selctedContGrpsForProfile = {
        contentGrps: []
      };
      this.displayPriceContentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
    }
    this.cmnService.emitTabIndex(this.tabIndex);
  }

  setLayout(selected) {
    this.LCGlayout = selected;
    this.cmnService.emitLayout(selected);
  }

  getDetailsOfPriceCG(id: string) {
    this.displayPriceContentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.previewTabIndex = 0;// IIT2_4655
        this.cmnService.scrollToBottom(id);
      }
    });
  }

  sortByDate() {
    this.page = 1;
    this.sortValue = GlobalConstants.CREATED_DATE;
    this.displayPriceContentGroups.sort((price1, price2) => price2.updateTime - price1.updateTime);
  }

  sortByName() {
    this.page = 1;
    this.sortValue = GlobalConstants.GROUP_NAME;
    this.displayPriceContentGroups.sort((price1, price2) =>
      price1.configurations.publishedName.localeCompare(price2.configurations.publishedName));
  }

  cancel() {
    this.dataService.setPriceContent(undefined);
    if (this.contentGrpData) {
      for (let each of this.displayPriceContentGroups) {
        if (each.id === this.contentGrpData.priceContent.id) {
          if (typeof each.configurations === 'string') {
            each.configurations = JSON.parse(each.configurations);
          }
          break;
        }
      }
    }
    this.getAllPriceContentsByUser();
    this.setIndex(0);
    this.mediaObjects = [];
    this.pages = {};
    this.clickable = false;
    this.editCheck = false;
  }

  /* Delete price content */
  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal(priceCGID: string) {
    this.priceCGToDelete = this.displayPriceContentGroups.find(ele => ele.id === priceCGID).id;
    this.priceCGToDeleteName = this.displayPriceContentGroups.find(ele => ele.id === priceCGID).configurations.publishedName;
    this.openModal(this.deleteModal);
  }

  openSendPriceContentToAccountModal(priceCGID: string) {
    this.sendButtonText = GlobalConstants.PRICE_BUTTON_TEXT;
    this.priceContentIdInfo = priceCGID;
    this.sendNameToStore = this.displayPriceContentGroups.find(ele => ele.id === priceCGID).configurations.publishedName;
    this.openModal(this.sendToAccountModal);
  }

  /* Delete price content */
  deletePriceCG(priceCGID: string) {
    // delete Price API call
    this.priceContentService.deletePriceContentById(priceCGID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        const index = this.displayPriceContentGroups.findIndex(d => d.id === priceCGID); // find index in your array
        if (index >= 0) {
          this.displayPriceContentGroups.splice(index, 1); // remove element from array
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          this.closeModal(this.deleteModal);
        });
  }

  updatePriceContent() {
    const updatePriceContent: CreatePriceContentResponse = this.contentGrpData as CreatePriceContentResponse;
    // Once page is updated.
    const priceContent = updatePriceContent.priceContent;
    if (typeof priceContent.configurations !== 'string') {
      priceContent.configurations = JSON.stringify(priceContent.configurations);
    }
    this.priceContentService.putPriceContentById(JSON.stringify(priceContent), updatePriceContent.priceContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putPriceContentResponse: CreatePriceContentResponse) => {
        // Once the update call is successful, make a PUT call for the logo
        for (const each of this.mediaObjects) {
          if (each.uploaded) {
            await this.updateMedia(each);
          }
        }
        this.deviceExists = putPriceContentResponse.priceContent.deviceExists;

        if (this.presentPage === this.profile_page) {
          this.openModal(this.showModal);
        } else if (this.editCheck && this.presentPage === this.assets_page && this.deviceExists) {
          this.openModal(this.applyModal);
        } else {
          this.pages = {};
          this.clickable = false;
          this.setIndex(0);
          this.getAllPriceContentsByUser();
        }

      },
        error => {
        }
      );
  }

  updateMedia(each) {
    return new Promise((resolve, reject) => {
      this.priceContentService.putS3PriceContentByPageId(each.media.fileObj,
        each.media.name.split('.')
          .pop(), each.id, each.pageNum.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((data) => {
          resolve(data);//To-Do: we should handle what if response code is other than 200
        },
          error => { // do something
          }
        );
    })
  }

  addNewPriceContent() {
    this.mediaObjects = [];
    this.dataService.setPriceContent(undefined);
    this.tabIndex = 1;
  }

  // Adding content group objects for profile
  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      'priceContentId': this.displayPriceContentGroups[ind].id,
      'showOnDevice': this.displayPriceContentGroups[ind].showOnDevice
    });
  }

  setPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displayPriceContentGroups[index].showOnDevice = this.displayPriceContentGroups[index].addToPackage = value;
  }

  // for AddToProfile
  findIndexAndSetValue(setValueTo: string, keyName: string, setValueAs: any) {
    if (setValueTo === GlobalConstants.DISPLAY_PRICE_CONTENT) {
      const checkInd = this.displayPriceContentGroups.findIndex(d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.displayPriceContentGroups[checkInd].showOnDevice = setValueAs;
    } else {
      const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps.findIndex(
        d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = setValueAs;
    }
  }

  removeShowonDevice() {
    this.displayPriceContentGroups.forEach(element => {
      element.isChecked = false;
    });
    this.selctedContGrpsForProfile.showOnDevice = undefined;
    this.selctedContGrpsForProfile.contentGrps.forEach(value => {
      value['showOnDevice'] = false;
    })
  }
  addToProfile(eventObj: any, index: number, eventSource: string) {
    // for radio button selection
    if (eventSource === GlobalConstants.RADIO) {
      // if switching show on device one to others
      if (!this.selctedContGrpsForProfile.showOnDevice && this.displayPriceContentGroups[index].addToPackage) {
        this.selctedContGrpsForProfile.showOnDevice = this.displayPriceContentGroups[index].id;
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.PRICE_CONTENT_ID, true);
        this.displayPriceContentGroups[index].showOnDevice = true;
      } // if show on device not selected.
      else if (this.selctedContGrpsForProfile.showOnDevice && this.displayPriceContentGroups[index].addToPackage) {
        this.findIndexAndSetValue(GlobalConstants.DISPLAY_PRICE_CONTENT, GlobalConstants.ID, false);
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.PRICE_CONTENT_ID, false);
        this.displayPriceContentGroups[index].showOnDevice = true;
        this.selctedContGrpsForProfile.showOnDevice = this.displayPriceContentGroups[index].id;
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.PRICE_CONTENT_ID, true);
      } else {
        eventObj.target.checked = false;
      }
    }
    // for checkbox  selection
    else if (eventSource === GlobalConstants.CHECK) {
      if (this.selctedContGrpsForProfile?.contentGrps?.length === 1 && (this.selctedContGrpsForProfile?.contentGrps[0]?.priceContentId === undefined
        || this.selctedContGrpsForProfile?.contentGrps[0]?.priceContentId === "")) {
        this.selctedContGrpsForProfile.contentGrps = [];
      }
      if (eventObj.target.checked) {
        if (this.selctedContGrpsForProfile.contentGrps?.length <= 2) {
          this.displayPriceContentGroups[index].addToPackage = eventObj.target.checked;
          this.pushToSelectedGrps(index);
        } else {
          eventObj.target.checked = false;
        }
      } else {
        if (this.displayPriceContentGroups[index].showOnDevice) {
          this.selctedContGrpsForProfile.showOnDevice = undefined;
        }
        this.setPackageNshowOnDeviceVal(index, false);
        const checkInd = this.selctedContGrpsForProfile.contentGrps.findIndex(
          d => d.priceContentId === this.displayPriceContentGroups[index].id);
        if (checkInd >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
        }
      }
    }
  }

  setDeviceAndPackage(ind: number, value: boolean) {
    this.displayPriceContentGroups[ind].showOnDevice = this.displayPriceContentGroups[ind].addToPackage = value;
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      if (!this.selctedContGrpsForProfile?.contentGrps?.length) {
        this.selctedContGrpsForProfile.contentGrps = [{
          'priceContentId': undefined,
          'showOnDevice': false,
        }];
      }
      this.cmnService.emitDataToProfile({ page: GlobalConstants.PRICE_CONTENT_GROUP, dataSet: this.selctedContGrpsForProfile.contentGrps });
      //gtm(google tag manager)
      window['dataLayer'].push({
        'price_content_added': true
      });
    } else {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.PRICE_CONTENT_GROUP, dataSet: GlobalConstants.SKIP });
    }
    this.cmnService.scrollTopInitial();
  }

  redirectToList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.showModal);
    // this.closeModal(this.applyModal);
    this.getAllPriceContentsByUser();
  }

  showOnDevice() {
    this.showDevice = true;
    this.redirectToList();
  }

  closeShowOnDevice() {
    this.showDevice = false;
    this.selctedContGrpsForProfile.contentGrps = [];
    this.selctedContGrpsForProfile.showOnDevice = false;
    this.redirectToList();
  }

  redirectToapplyList() {
    this.pages = {};
    this.clickable = false;
    this.setIndex(0);
    this.closeModal(this.applyModal);
    // this.closeModal(this.applyModal);
    this.getAllPriceContentsByUser();
  }

  applyToDevice(applyDevice: boolean) {
    const updatePriceContent: CreatePriceContentResponse = this.contentGrpData as CreatePriceContentResponse;
    // Once page is updated.
    const priceContent = updatePriceContent.priceContent;
    if (typeof priceContent.configurations !== 'string') {
      priceContent.configurations = JSON.stringify(priceContent.configurations);
    }
    priceContent.ispushedToDevice = applyDevice;
    priceContent.showOnDevice = applyDevice;
    if (!applyDevice) {
      priceContent.deviceExists = false;
    }
    else {
      priceContent.deviceExists = this.deviceExists;
    }
    this.priceContentService.putPriceContentById(JSON.stringify(priceContent), updatePriceContent.priceContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putPriceContentResponse: CreatePriceContentResponse) => {
        this.redirectToapplyList();
      },
        error => {

        });
  }

  closeApplyDevice() {
    this.showDevice = false;
    this.selctedContGrpsForProfile.contentGrps = [];
    this.selctedContGrpsForProfile.showOnDevice = false;
    this.redirectToapplyList();
  }

  navigate() {
    this.isNavigated = true;
    this.contentGrpData.priceContent.configurations.formFactor =
      Utils.getFormFactorNames(this.contentGrpData.priceContent.configurations.formFactor);
    if (this.contentGrpData.priceContent && this.contentGrpData.priceContent.configurations) {
      if (
        this.contentGrpData.priceContent.configurations?.publishTime &&
        !this.contentGrpData.priceContent.configurations.isPublishDateNow
      ) {
        //changing it to old format
        this.contentGrpData.priceContent.configurations.publishTime =
          Utils.ChangetoOldFormat(
            this.contentGrpData.priceContent.configurations.publishTime
          );
      }
      if (
        this.contentGrpData.priceContent.configurations.expireTime &&
        this.contentGrpData.priceContent.configurations.expireTime !== GlobalConstants.NEVER
      ) {
        //changing it to old format
        this.contentGrpData.priceContent.configurations.expireTime =
          Utils.ChangetoOldFormat(
            this.contentGrpData.priceContent.configurations.expireTime
          );
      }
    }
    this.dataService.setPriceContent(this.contentGrpData.priceContent);
    this.setIndex(1);
    this.clickable = false;
  }
  tabTrimString(data: string) {
    return Utils.trimString(data);
  }

  getSelectedStoreData(data) {
    this.sendToStoreService.sendPriceToStoreService(this.priceContentIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isSendToStore = true;
        }
      });
  }
  //IIT2_4655
  previewNavigate(ind, id) {
    this.displayPriceContentGroups.forEach(element => {
      if (element.id === id) {
        element.previewTabIndex = ind;
      }
    });
  }

}
